module.exports = {"items":[{"title":"Filme","count":297,"image":"07_icon_film.gif"},{"title":"GB Daten","count":42000,"image":"08_icon_data.gif"},{"title":"Kunden","count":93,"image":"09_icon_clients.gif"},{"title":"Awards","count":34,"image":"10_icon_award.gif"},{"title":"Stunden","count":129132,"image":"11_icon_time.gif"},{"title":"Kaffee","count":57392,"image":"12_icon_coffee.gif"}]}


//////////////////
// WEBPACK FOOTER
// ./public/content/sections/counter.json
// module id = 913
// module chunks = 0